<template>
  <div class=" commonHeader">
    <div class="header">
      <div class="icon-left" @click="showPopup">
        <img src="/static/img/index/icon-left.png" alt="" />
      </div>
      <div class="icon-logo">
        <img src="/static/img/index/logo.png?v=0" alt="" />
      </div>
      <div class="icon-right"></div>
    </div>
    <van-popup
      :closeable="true"
      v-model="show"
      position="left"
      close-icon-position="top-left"
      :style="{ height: '100%', width: '70%' }"
    >
      <div class="list">
        <div class="menu-item" @click="routerLink('/index', null, '首页')">
          <img
            class="menu-item__icon-img"
            src="../assets/icon/home.png"
            alt=""
          />
          <span class="menu-item__text">首页</span>
        </div>
        <div class="menu-item" @click="openMiniProgram">
          <img
            class="menu-item__icon-img"
            src="../assets/icon/product.png"
            alt=""
          />
          <span class="menu-item__text">产品与服务</span>
        </div>
        <van-collapse
          class="menu-group-item"
          v-model="activeNames"
          style="height:auto"
        >
          <van-collapse-item name="1">
            <template #title>
              <div
                class="commonHeader-title menu-group-item__title"
                style="padding:0"
              >
                <img
                  class="menu-item__icon-img"
                  src="../assets/icon/school.png"
                  alt=""
                />
                <span class="menu-item__text">百科资讯</span>
              </div>
            </template>
            <ul class="submenu-list">
              <li
                v-for="(item, k) in submenuList"
                :key="item.id"
                class="submenu-item"
                @click="routerLink(`/VAT?active=${k}`, null, item.name)"
              >
                <span class="submenu-item__circle"></span>
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </van-collapse-item>
        </van-collapse>
        <div
          class="menu-item"
          @click="routerLink('/aboutUs', null, '关于我们')"
        >
          <img
            class="menu-item__icon-img"
            src="../assets/icon/about-us.png"
            alt=""
          />
          <span class="menu-item__text">关于我们</span>
        </div>
      </div>
    </van-popup>
    <img
      v-if="!ISYS&&!ISLY"
      class="kefu-img"
      @click="qimoChatClick"
      src="https://cdn.evatmaster.com/ost/2101307917bb408975460cbe96a3879000e3eb.png"
      alt=""
    />
  </div>
</template>

<script>
import { linkToProgram, getCatalogueList } from '@/api/land.js'
import { getCookie } from '@/util/util'
import { mixinCheckResponseIsErr } from '@ost/static/lib/mixin'
import sensors from '@/util/sensors.js'
import { COOKIE_TIME_STR } from '@ost/static'
import { mapGetters } from 'vuex'

export default {
  mixins: [mixinCheckResponseIsErr],
  props: ['url', 'loginFlag'],
  data () {
    return {
      activeNames: [''],
      show: false,
      phone: '',
      isPhone: false,
      submenuList: [] // 子菜单列表
    }
  },
  created () {
    let hm = document.createElement('script')
    hm.async = true
    hm.src =
      'https://classic-webchat.7moor.com/javascripts/7moorInit.js?accessId=4661a500-c04a-11ec-b63e-b91dd72c431f&autoShow=false&language=ZHCN'
    let s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
    let phone = navigator.userAgent // 设备机型的相关信息
    this.phone = phone.substring(phone.indexOf('(') + 1, phone.indexOf(';')) // 处理信息，输出phone
    this.isPhone =
      phone.indexOf('Windows') === -1 && phone.indexOf('Macintosh') === -1
    this.getSubmenuList()
  },
  watch: {
    '$store.state.needChannelUrl': {
      handler: function (newVal) {
        if (newVal && this.$route.query.channelNo) {
          //  变化
          let channelCode = ''
          // 不变
          let channelNo = ''
          let href2 = '.ippmaster.com'
          if (window.location.href.indexOf('ippmaster.com') !== -1) {
            href2 = '.ippmaster.com'
          } else {
            href2 = '.ost.com'
          }
          channelCode = this.$route.query.channelNo
          channelNo = this.$route.query.channelNo
          document.cookie = `channelCode=${channelCode};path=/;domain=${href2}${COOKIE_TIME_STR}`
          if (!getCookie('channelNo')) {
            document.cookie = `channelNo=${channelNo};path=/;domain=${href2}${COOKIE_TIME_STR}`
          }
        }
      },
      immediate: true
    }
  },
  computed:{
    ...mapGetters(['isLiDo', 'isOST', 'ISYS','ISLY'])
  },
  methods: {
    qimoChatClick () {
      window.qimoClientId = {
        customField: {
          是否已下单: '未下单', // 是否已下单（0：否 1：是）
          用户状态: '游客' // 这里的客服是必须登录才能看到
        }
      }
      window.qimoChatClick()
    },
    async getSubmenuList () {
      const res = await getCatalogueList(3).catch(e => null)

      if (this.checkResponseIsErr(res)) {
        return false
      }

      this.submenuList = res.data.titleList || []
    },
    /**
     * @description 控制折叠面板的显示
     */
    showPopup () {
      this.show = true
    },
    /**
     *@desctiption 根据环境判断跳转小程序或者商户端
     */
    toLoginStatus (type) {
      if (this.isPhone) {
        linkToProgram({
          path: 'minePages/pages/Login/index',
          channelNo: this.$route.query.channelNo || '',
          pageType: 'index',
          fromType: 'H5',
          H5ClickType: 1
        })
          .then(res => {
            if (res.code === 0) {
              window.location.href = res.data
            } else {
              this.$toast({ message: '系统繁忙，请稍后重试' })
            }
          })
          .catch(() => {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          })
      } else {
        this.redirectLogin(
          `user/register?channelCode=${this.$route.query.channelNo}`,
          '_blank'
        )
      }
    },
    /**
     * @description 跳转注册页面
     */
    toRegistered () {
      this.toLoginStatus(1)
    },
    /**
     * 打开小程序的购买页
     */
    openMiniProgram () {
      sensors('OfficialWebsiteNavigationClick', {
        navigation_name: '产品与服务'
      })
      if (
        this.phone.indexOf('Windows') !== -1 ||
        this.phone.indexOf('Macintosh') !== -1
      ) {
        this.redirectLogin('buy', '_blank')
        return false
      }

      linkToProgram({ path: 'pages/buy/buy' })
        .then(res => {
          if (res.code === 0) {
            window.location.href = res.data
          } else {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          }
        })
        .catch(() => {
          this.$toast({ message: '系统繁忙，请稍后重试' })
        })
    },
    redirectLogin (url, type) {
      // 方法在这
      let href = window.location.href
      let urlHeader =
        href.indexOf('uat-m.ippmaster.com') !== -1
          ? 'https://uat-user.ippmaster.com/'
          : href.indexOf('m.ippmaster.com') !== -1
            ? 'https://user.ippmaster.com/'
            : `http://${window.location.hostname}:9001/`
      window.open(urlHeader + url, type)
    },
    userConfirm (url) {
      this.$dialog
        .confirm({
          title: '即将打开“麦德通”小程序',
          cancelButtonText: '取消',
          confirmButtonText: '打开',
          confirmButtonColor: '#576B95'
        })
        .then(() => {
          window.location.href = url
        })
        .catch(() => {
          // nothing to do
        })
    },

    /**
     * @description 折叠面板的list点击跳转事件
     */
    routerLink (e, id, name) {
      if (name) {
        sensors('OfficialWebsiteNavigationClick', {
          navigation_name: name
        })
      }
      if (e === '/VAT') {
        this.$store.state.vatActive = id
      }
      this.show = false
      setTimeout(() => {
        if (this.url === e) {
          this.$router.go(0)
        } else {
          this.$router.push(e)
        }
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }, 300)
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem;
  position: fixed;
  top: 0;
  background: white;
  width: 100%;
  z-index: 1000;
  max-width: 768px;
  margin: auto;
}

.icon-left {
  width: 0.41rem;
  height: 0.3rem;
  /* margin-top: 0.14rem; */
}

.icon-logo {
  width: 1.07rem;
  height: 0.37rem;
}

.icon-right {
  width: 0.37rem;
  height: 0.41rem;
  /* margin-top: 0.14rem; */
}

.header img {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.list {
  margin-top: 2rem;
}

.list > .menu-item,
.list > .menu-group-item,
.title {
  // height: 1.3rem;
  // line-height: 1.3rem;
  // text-align: left;
  // padding-left: 1rem;
  // font-size: 0.3rem;
  // border: 0 none;
}

.list > .van-collapse {
  &::after,
  &::before {
    display: none;
  }
}

.menu-item,
.menu-group-item {
  box-sizing: border-box;
  padding: 0 0.6rem;
  margin-bottom: 0.69rem;
}

.menu-item {
  display: flex;
  align-items: center;

  &__icon-img {
    width: 0.36rem;
    margin-right: 0.16rem;
  }

  &__text {
    font-size: 0.34rem;
    line-height: 1;
    color: #333;
  }
}

.menu-group-item {
  &__title {
    display: flex;
    align-items: center;
  }

  ::v-deep .van-cell__right-icon {
    height: auto;
    font-size: 0.36rem;
    line-height: 1;
    color: #333;
  }

  ::v-deep .van-collapse-item__title {
    align-items: center;
    padding: 0;
  }

  ::v-deep .van-collapse-item__content {
    padding: 0 0 0 0.52rem;
  }

  .submenu-list {
    margin: 0;
  }

  .submenu-item {
    display: flex;
    align-items: center;
    margin-top: 0.49rem;
    text-align: left;
    font-size: 0.34rem;
    line-height: 1;
    color: #666666;

    &__circle {
      width: 0.08rem;
      height: 0.08rem;
      border-radius: 50%;
      margin-right: 0.16rem;
      background: #1363f7;
    }
  }
}
</style>
<style>
.commonHeader .van-cell__right-icon {
  line-height: 1.3rem;
}

.commonHeader .van-cell {
  padding: 0 0.2rem 0 0;
}

.commonHeader .van-cell::after {
  display: none;
}

.kefu-img {
  width: 1rem !important;
  bottom: 208px;
  height: 1rem !important;
  position: fixed;
  right: 5px;
  z-index: 999 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue